import { Controller } from "@hotwired/stimulus";
import { debounce } from "hb/lib/utils";

export default class extends Controller {
  static targets = ["input", "frame"];
  static values = {
    url: String,
  };

  connect() {
    this.updateFrameSrcDebounce = debounce(this.updateFrameSrc.bind(this), 100);
  }

  disconnect() {
    this.updateFrameSrcDebounce(null);
  }

  updatePreview() {
    this.updateFrameSrcDebounce(this.inputTarget.value);
  }

  updateFrameSrc(value) {
    this.frameTarget.setAttribute(
      "src",
      `${this.urlValue}?destination_id=${value}`,
    );
    this.frameTarget.reload();
  }
}
